<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GLwZH1/tc-custom/9781439676486.jpg?1702529786950" alt="This image is the cover for the book Filmed in Brooklyn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Filmed in Brooklyn
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Shooting in Brooklyn is like opening a time capsule. Nothing has changed. Everything looks like it did in the eighties." -Freddie Prinze, Jr. </b></p><p></p><p>Discover the iconic films, legendary personalities and the locations for timeless big screen moments that took place in Brooklyn. From Saturday Night Fever to numerous Spike Lee Joints, readers can learn about Brooklyn's cinematic past or discover locations to visit today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margo Donohue
      </h2>
      
      <p class="authorDescription body article">Margo Donohue is the co-host, co-creator, editor and producer of several podcasts, including <I>Book Vs. Movie, Dorking Out, Not Fade Away</I> and <I>What a Creep</I>. Her work can be found at www.BrooklynFitChick.com, and her social media handle is "Brooklyn Fit Chick" on Twitter & Instagram. You can find her trying to ruin TikTok for the millennials @margodonohue. <I>Filmed in Brooklyn</I> is her first book. She is a twenty-five-plus-year Brooklynite who comes by way of the West Coast via San Jose State University. She is a writer, photographer, public relations pro, marketer, social media diva and content creator with more than twenty years of experience in entertainment, features, films and lifestyle media.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef5ef1a0